import { createReducer, on } from "@ngrx/store";
import { findHolidayGroupsCatalogAct, loadAreasCatalogAct, loadBenefitGroupsCatalogAct, loadBenefitsCatalogAct, loadBenefitTypeCatalogAct, loadCostsPerEmployeeGroupsCatalogAct, loadCostsPerEmployeesCatalogAct, loadCostsPerEmployeeTypeCatalogAct, loadDivisionsCatalogAct, loadFormulaGroupsCatalogAct, loadHolidayGroupsCatalogAct, loadObjectsCatalogAct, loadSignatureGroupsCatalogAct, loadSignatureTypeCatalogAct,
    loadUsersWithRolAutCatalogAct, 
    loadVariablesCatalogAct, 
    loadWithholdingGroupsCatalogAct, 
    loadWithholdingsCatalogAct, 
    loadWithholdingTypeCatalogAct} from "./catalog-offer.actions";
import { Division } from "../../models/division";
import { Area } from "../../models/area";
import { Position } from "../../models/position";
import { BenefitType } from "../../models/benefit-type";
import { Benefit } from "../../models/benefit";
import { User } from "../../models/user";
import { SignatureType } from "../../models/signature-type";
import { SignatureGroup } from "../../models/signature-group";
import { BenefitGroup } from "../../models/benefit-group";
import { HolidayGroup } from "../../models/holiday-group";
import { WithholdingType } from "../../models/withholding-type";
import { CostsPerEmployeeType } from "../../models/cost-per-employee-type";
import { CostsPerEmployee } from "../../models/cost-per-employee";
import { Withholding } from "../../models/withholding";
import { Variable } from "../../models/formulas/variable";
import { ObjectF } from "../../models/formulas/object";
import { WithholdingGroup } from "../../models/withholding-group";
import { FormulaGroup } from "../../models/formulas/formula-group";
import { CostsPerEmployeeGroup } from "../../models/cost-per-employee-group";

const divisions: Division[] = [];
const areas: Area[] = [];
const positions: Position[] = [];
const benefitTypes: BenefitType[] = [];
const benefits: Benefit[] = [];
const usersWithRolAut: User[] = [];
const signatureTypes: SignatureType[] = [];
const signatureGroups: SignatureGroup[] = [];
const benefitGroups: BenefitGroup[] = [];
const holidayGroups: HolidayGroup[] = [];
const withholdings: Withholding[] = [];
const withholdingTypes: WithholdingType[] = [];
const costsPerEmployees: CostsPerEmployee[] = [];
const costsPerEmployeeTypes: CostsPerEmployeeType[] = [];
const variables: Variable[] = [];
const objects: ObjectF[] = [];
const withholdingGroups: WithholdingGroup[] = [];
const formulaGroups: FormulaGroup[] = [];
const costsPerEmployeeGroups: CostsPerEmployeeGroup[] = [];

export const catalogOfferReducer = createReducer(
    {
        divisions,
        areas,
        positions,
        benefitTypes,
        benefits,
        usersWithRolAut,
        signatureTypes,
        signatureGroups,
        benefitGroups,
        holidayGroups,
        withholdings,
        withholdingTypes,
        costsPerEmployees,
        costsPerEmployeeTypes,
        variables,
        objects,
        withholdingGroups,
        formulaGroups,
        costsPerEmployeeGroups
    },
    on(loadDivisionsCatalogAct, (state, { divisions }) => ({
        divisions: divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadAreasCatalogAct, (state, { areas }) => ({
        divisions: state.divisions,
        areas: areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadBenefitTypeCatalogAct, (state, { benefitTypes }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: [...benefitTypes],
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadSignatureTypeCatalogAct, (state, { signatureTypes }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: [...signatureTypes],
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadUsersWithRolAutCatalogAct, (state, { usersWithRolAut }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: [...benefitTypes],
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: [...usersWithRolAut],
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadBenefitsCatalogAct, (state, { benefits }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadSignatureGroupsCatalogAct, (state, { signatureGroups }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: [...signatureGroups],
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadBenefitGroupsCatalogAct, (state, { benefitGroups }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: state.signatureGroups,
        benefitGroups: [...benefitGroups],
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadHolidayGroupsCatalogAct, (state, { holidayGroups }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: [...holidayGroups],
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadWithholdingsCatalogAct, (state, { withholdings }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: [...withholdings],
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadWithholdingTypeCatalogAct, (state, { withholdingTypes }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: [...withholdingTypes],
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadCostsPerEmployeesCatalogAct, (state, { costsPerEmployees }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: [...costsPerEmployees],
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadCostsPerEmployeeTypeCatalogAct, (state, { costsPerEmployeeTypes }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: [...costsPerEmployeeTypes],
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadVariablesCatalogAct, (state, { variables }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadObjectsCatalogAct, (state, { objects }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadWithholdingGroupsCatalogAct, (state, { withholdingGroups }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: [...withholdingGroups],
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadFormulaGroupsCatalogAct, (state, { formulaGroups }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: [...formulaGroups],
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
    })),
    on(loadCostsPerEmployeeGroupsCatalogAct, (state, { costsPerEmployeeGroups }) => ({
        divisions: state.divisions,
        areas: state.areas,
        positions: state.positions,
        benefitTypes: state.benefitTypes,
        benefits: state.benefits,
        signatureTypes: state.signatureTypes,
        usersWithRolAut: state.usersWithRolAut,
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdings: state.withholdings,
        withholdingTypes: state.withholdingTypes,
        costsPerEmployees: state.costsPerEmployees,
        costsPerEmployeeTypes: state.costsPerEmployeeTypes,
        variables: state.variables,
        objects: state.objects,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: [...costsPerEmployeeGroups]
    }))
)